export default {
  SELECTION_WRAPPER_ID: 'selected-text',
  SELECTION_CLASSNAME: 'ws-temp-selected',
  SELECTION_TAG_NAME: 'span',
  SELECTION_STYLE:
    'background: rgba(35, 131, 226, 0.28); box-shadow: 0 -3px 0 0 rgba(35, 131, 226, 0.28), 0 3px 0 0 rgba(35, 131, 226, 0.28)',
};
